import { useQuery } from 'react-query';

import { apiClient } from '../../services/ApiClient';
import { Queries, QueryCacheConfig } from '../../constants/query-constants';
import { ApiEndpoints } from '../../constants/api-constants';
import type { OperationViewModel } from '../../components/Map/types';

export const useGetOperations = (): OperationViewModel[] => {
  const getOperations = async (): Promise<any> => {
    return (await apiClient.get<OperationViewModel[]>(ApiEndpoints.operations)) ?? [];
  };

  const { data } = useQuery({
    ...QueryCacheConfig[Queries.Operations],
    queryKey: Queries.Operations,
    queryFn: getOperations,
  });

  return data;
};
